import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { LOCATION_CHANGE } from "connected-react-router";

import { addMessage } from "../../../../../redux/actions/messagesActions";
import { Effect } from "../../../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../../../redux/action.functions";

import * as productService from "../services/work-order-products.service";

import * as actions from "./work-order-products.actions";
import { WorkOrderProductsActions } from "./work-order-products.actions";

const addProduct: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(WorkOrderProductsActions.AddProduct)),
    map((action) => action.payload),
    mergeMap(({ product, workOrderId }) =>
      productService.addProduct(product, workOrderId).pipe(
        map((product) => actions.addProductSuccess(product)),
        catchError((error) => of(actions.addProductFailure(error)))
      )
    )
  );

const fetchProducts: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(WorkOrderProductsActions.FetchProducts)),
    map((action) => action.payload),
    mergeMap(({ workOrderId }) =>
      productService.fetchProducts(workOrderId).pipe(
        map(({ results }) => actions.fetchProductsSuccess(results)),
        catchError((error) => of(actions.fetchProductsFailure(error)))
      )
    )
  );

const reset: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter((action) => action.type === LOCATION_CHANGE),
    map(() => actions.reset())
  );

const updateProducts: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(WorkOrderProductsActions.UpdateProducts)),
    map((action) => action.payload),
    mergeMap(({ products, workOrderId }) =>
      productService.updateProducts(products, workOrderId).pipe(
        map(({ products }) => actions.updateProductsSuccess(products)),
        catchError((error) => of(actions.updateProductsFailure(error)))
      )
    )
  );

const updateProductsSuccess: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(WorkOrderProductsActions.UpdateProductsSuccess)),
    map(() => addMessage({ text: "Products saved successfully.", severity: "success" }))
  );

export const WorkOrderProductsEffects = [
  addProduct,
  fetchProducts,
  reset,
  updateProducts,
  updateProductsSuccess,
];
